import localeApi from "api/locale";
import { STAFF_MANAGE_TRANSALATION } from "constants/";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        lng: process.env.REACT_APP_DEFAULT_LOCALE,
        resources: {
            [process.env.REACT_APP_DEFAULT_LOCALE]: {
                translation: ''
            }
        },
        interpolation: {
            escapeValue: false // react already safes from xss
        },
        keySeparator: '>', // fix colon in text
        nsSeparator: '|',
    });

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)

export const setUiLocale = (lang) => {
    const messages = localStorage.getItem(STAFF_MANAGE_TRANSALATION)

    if (messages) {
        i18n
            .use(initReactI18next) // passes i18n down to react-i18next
            .init({
                lng: lang,
                resources: {
                    [lang]: {
                        translation: JSON.parse(messages)
                    }
                },
                interpolation: {
                    escapeValue: false // react already safes from xss
                },
                keySeparator: '>', // fix colon in text
                nsSeparator: '|',
            });
    }

    return localeApi.getMessages()
        .then((response) => response.messages)
        .then(
            loadedResources => {
                new Promise((resolve, reject) => {
                    localStorage.setItem(STAFF_MANAGE_TRANSALATION, JSON.stringify(loadedResources))
                    i18n
                        .use(initReactI18next) // passes i18n down to react-i18next
                        .init({
                            lng: lang,
                            resources: {
                                [lang]: {
                                    translation: loadedResources
                                }
                            },
                            interpolation: {
                                escapeValue: false // react already safes from xss
                            },
                            keySeparator: '>', // fix colon in text
                            nsSeparator: '|',
                        },
                            (err) => {
                                if (err) {
                                    reject(err);
                                    return;
                                }
                                resolve();
                            });
                })
            }
        ).catch((err) => Promise.reject(err))
}

export default i18n;